import { handleAuthorization, handleOkResponseJson, handleBadRequest400 } from "./handlers"
import { obterToken } from "./loginService"
import * as axios from 'axios';

export default {
    obterEmpresasAsync,
    enviarEmpresaAsync,
    editarEmpresaAsync,
	downloadLista,
	buscarCepAsync
}

export const obterEmpresasAsync = async () => {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
    };
    return fetch(`${process.env.VUE_APP_API_URL}/Empresa/obterLista`, requestOptions)
        .then(handleAuthorization)
        .then(handleOkResponseJson)
        .then(result => {
            return result.data;
        });
}

export const enviarEmpresaAsync = async (nome, cpf_cnpj, inscricaoEstadual, telefone, cep, endereco, numero, complemento, bairro, cidade, uf, logo) => {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
        body: JSON.stringify({ nome, cpf_cnpj, inscricaoEstadual, telefone, cep, endereco, numero, complemento, bairro, cidade, uf, logo })
    };
    return fetch(`${process.env.VUE_APP_API_URL}/Empresa`, requestOptions)
        .then(handleAuthorization)
        .then(handleBadRequest400);
}

export const editarEmpresaAsync = async (id, nome, cpf_cnpj, inscricaoEstadual, telefone, cep, endereco, numero, complemento, bairro, cidade, uf, logo, ativo) => {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
        body: JSON.stringify({ id, nome, cpf_cnpj, inscricaoEstadual, telefone, cep, endereco, numero, complemento, bairro, cidade, uf, logo, ativo })
    };
    return fetch(`${process.env.VUE_APP_API_URL}/Empresa/atualizar`, requestOptions)
        .then(handleAuthorization)
        .then(handleBadRequest400);
}

export const buscarCepAsync = async (cep) => {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() }
    };
    return fetch(`${process.env.VUE_APP_API_URL}/Endereco/consultaCep/` + cep, requestOptions)
        .then(handleAuthorization)
        .then(handleOkResponseJson)
        .then(result => {
            return result.data;
        });
}

export function downloadLista() {
	try {
		return axios({
			url: `${process.env.VUE_APP_ROOT_API}/Empresa/downloadEmpresas`,
			method: 'GET',
			responseType: 'blob',
			headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
		}).catch(() => {
			return { status: false };
		})
			.then((response) => {
				if (response.status === false)
					return response;
				var fileURL = window.URL.createObjectURL(new Blob([response.data]));
				var fileLink = document.createElement('a');

				fileLink.href = fileURL;
				fileLink.setAttribute('download', 'empresas' + '.xlsx');
				document.body.appendChild(fileLink);

				fileLink.click();
			});
	} catch (e) {
		throw e;
	}
}